module.exports = __webpack_public_path__ + "media/application/images/svgs/pause-0022fbadbe3bbdd07bc0b24af79b73f0.svg";